import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ColorsListDropDown from "../../../common/components/input/ColorsListDropDown";
import SelectMultiLevel from "../../../common/components/input/Menu/SelectMultiLevel";
import styled, { css } from "styled-components";
import { StyledTooltip } from "../../../common/utils/StyledTooltip";
import ColorsSet from "../../../common/utils/ColorsSet";

function DropdownRowColoring({
  setRowColorsBasedOnDropdown,
  handleColorButtonSave,
  dropdownColumns,
  rowColorsBasedOnDropdown,
}) {
  let selectedDropdownColumnOptions = [],
    selectedDropdownColumnColors = [],
    selectedDropdownColumn = dropdownColumns.find((dropdownCol) => {
      return dropdownCol.id == rowColorsBasedOnDropdown?.column_id;
    });
  if (selectedDropdownColumn?.options) {
    selectedDropdownColumnOptions = JSON.parse(
      selectedDropdownColumn.options
    )[0].options;
    selectedDropdownColumnColors = JSON.parse(selectedDropdownColumn.options)[0]
      .colors;
  }
  const handleSelectedDropdownColumn = (colId) => {
    setRowColorsBasedOnDropdown({
      color: "",
      bg_color: "",
      criteria: {
        query_string: "",
        query_tree: [],
      },
      column_id: colId,
      is_dropdown_row_coloring: 1,
    });
  };

  React.useEffect(() => {
    if (
      dropdownColumns.length > 0 &&
      Object.keys(rowColorsBasedOnDropdown).length === 0
    ) {
      handleSelectedDropdownColumn(dropdownColumns[0].id);
    }
  }, []);

  return (
    <StyledGrid container>
      <StyledInnerGrid container>
        <StyledInnerGridItem item>
          <StyledTooltip title="Remove color">
            <StyledDeleteIcon
              onClick={() => {
                handleSelectedDropdownColumn("");
                handleColorButtonSave(true);
              }}
            />
          </StyledTooltip>
        </StyledInnerGridItem>
        <StyledInnerGridItem item>
          Coloring records the same as
        </StyledInnerGridItem>
        <StyledDiv></StyledDiv>
        <StyledInnerGridItem item xs={3}>
          <SelectMultiLevel
            values={dropdownColumns}
            valueKey="name"
            displayKey="name"
            value={selectedDropdownColumn}
            label="Find a Column"
            fullWidth
            onChange={(col) => handleSelectedDropdownColumn(col.id)}
          />
        </StyledInnerGridItem>
      </StyledInnerGrid>
      <StyledSeparator></StyledSeparator>
      {selectedDropdownColumnOptions?.map((option, index) => (
        <StyledDropdownGrid key={index} container>
          <StyledDropdownGridItem xs={11} item>
            <ColorsListDropDown
              colors={ColorsSet}
              onChange={(col) => {}}
              value={selectedDropdownColumnColors[index]}
              isColorsListDisabled={true}
            />
          </StyledDropdownGridItem>
          <StyledDropdownGridItem xs={11} item>
            <div> {option} </div>
          </StyledDropdownGridItem>
        </StyledDropdownGrid>
      ))}
    </StyledGrid>
  );
}

const StyledGrid = styled(Grid)`
  padding: 10px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
`;

const StyledInnerGrid = styled(Grid)`
  padding: 5px 5px 10px 5px;
  display: flex;
  align-items: center;
`;

const StyledInnerGridItem = styled(Grid)`
  margin-right: 6px !important;
  display: flex;
`;

const StyledSeparator = styled.div`
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
  width: 100%;
`;

const StyledDropdownGrid = styled(Grid)`
  padding: 2px;
  display: flex;
  align-items: center;
`;

const StyledDropdownGridItem = styled(Grid)`
  margin-right: 6px !important;
  display: flex;
  flex-basis: auto !important;
`;

const StyledDeleteIcon = styled(DeleteIcon)`
  font-size: 12px !important;
`;

const StyledDiv = styled.div`
  flex: 1 0 0;
`;

export default DropdownRowColoring;
